import Vue from 'vue'
import {gaSendEvent, gaSendExperiment, gaSendPageview, installGoogleAnalytics} from "@/components/Analytics";
import Home4 from "@/views/Home4.vue";
import FacebookReviews from "@/components/FacebookReviews.vue";

installGoogleAnalytics();
Vue.config.productionTip = false;

new Vue({
  render: h => h(Home4)
}).$mount('#home2-mount');
new Vue({
  render: h => h(FacebookReviews)
}).$mount("#facebook-reviews-mount");

gaSendPageview("/");
gaSendEvent("Landing V4 ON", {});
